<template>
  <div class="search">
    <div class="searchbody container">
      <div class="searchbodytitle">
        <h1 class="title_font2" v-if="q == ''">
          {{ $t("home.search_our_store") }}
        </h1>
        <h1
          class="title_font2"
          v-else-if="q != '' && products_page.data.length"
        >
          {{
            `${$t("search.your_search_for")}"${q}" ${$t(
              "search.revealed_the_following"
            )}`
          }}
        </h1>
        <h1 class="title_font2" v-else>
          {{
            `${$t("search.your_search_for")}"${q}" ${$t("search.not_results")}`
          }}
        </h1>
        <v-line></v-line>
      </div>
      <div class="searchinput">
        <input
          class="secondary_title"
          type="text"
          :placeholder="$t('home.search_our_store')"
          v-model="search"
          autofocus
          name="q"
          autocomplete
          @keyup.enter="searchcommondity()"
        />
        <span class="iconfont" @click="searchcommondity">&#xe618;</span>
      </div>
      <div
        class="d-block d-md-none default-mb-filter"
        v-if="filter_onoff"
        style="margin: 15px auto 30px; width: 300px"
      >
        <v-productFilter
          :product_filter="product_filter_res"
          :api_get_product="api_get_product"
        ></v-productFilter>
      </div>
      <div :class="filter_onoff ? 'filter_flex' : ''">
        <div
          v-if="filter_onoff"
          class="col-md-3 d-none d-md-block"
          style="padding: 0 30px 0 20px"
          :style="{
            position: product_filter_fixed ? 'sticky' : 'static',
            top: product_filter_top + 50 + 'px',
          }"
        >
          <v-productFilter
            :product_filter="product_filter_res"
            :api_get_product="api_get_product"
          ></v-productFilter>
        </div>
        <div
          class="row searchresult"
          :style="{ marginTop: filter_onoff ? 0 : '' }"
          v-if="products_page.data.length > 0"
        >
          <div
            class="col-md-4 col-sm-6"
            v-for="(item, index) in products_list"
            :key="index"
          >
            <v-commoditylistitemcard
              model="is_card"
              :custom_button="
                is_custom_button &&
                mix_custom_button_list &&
                mix_custom_button_list[item.ID] &&
                mix_custom_button_list[item.ID]['custom_button']
              "
              :productDetail="item"
              classtype="thumbnail"
              imgsize="(max-width: 358px) 189px,
            (max-width: 576px) 295px,
            (max-width: 768px) 135px,
            (max-width: 992px) 189px,
             215px"
              :palette_config="palette_config"
              :isShowMainImg="true"
            ></v-commoditylistitemcard>
            <!-- <v-commodityitem :product="item"></v-commodityitem> -->
          </div>
        </div>
        <div
          class="text-center page_text_font"
          style="margin: 80px auto 0"
          v-else
        >
          <h5 class="page_text_font">{{ $t("productList.no_products") }}</h5>
          <p
            class="iconfont"
            style="font-size: 80px; color: #e4e4e4; margin: 18px 0"
          >
            &#xe64c;
          </p>
        </div>
      </div>
      <div
        class="paging"
        v-if="products_page.last_page > 1"
        style="margin-top: 30px"
      >
        <el-pagination
          :page-size="products_page.per_page"
          :current-page="products_page.current_page"
          layout="prev, pager, next"
          :total="products_page.total"
          @current-change="page"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
// import API from "../../API";
import vCommodityitem from "../common/commodityitem";
import { mapActions } from "vuex";
import mixFilter from "@/js/mixins/mixFilter";
import mixGetPlugs from "@/js/mixins/mixGetPlugs"

export default {
  props: [
    "products",
    "q",
    "is_custom_button",
    "palette_config",
    "product_filter",
    "product_tag",
  ],
  data() {
    return {
      num: 1,
      to: 100,
      title: "Search",
      search: "",
      products_page: {},
      products_list: [],
      products_ids: [],
    };
  },
  mixins: [mixFilter,mixGetPlugs],
  methods: {
    ...mapActions({
      get_product_tag: "change_product_tag_list", // 将 `this.get_product_tag()` 映射为 `this.$store.dispatch('change_product_tag_list')`
      get_product_palette: "get_product_palette", //获取产品调色板
    }),
    showleftmenu() {
      this.$(".search").animate({ left: "300px" }, 300);
      this.$("body").css({ overflow: "hidden" });
    },
    hiddenleftmenu() {
      this.$refs.son.showmenu = true;
      this.$(".search").animate({ left: "0" }, 300);
      this.$("body").css({ overflow: "" });
      this.$(".pricelist").css("display", "none");
    },
    searchcommondity() {
      this.send_fb_event("Search", { search_string: this.search });
      if (window.ttq && window.send_ttp_event) {
        window.send_ttp_event('Search',{query:this.search})
      }
      //搜索时snapchat的 SEARCH 事件
      if(window.snaptr){
        window.snaptr('track', 'SEARCH',{'search_string':this.search_string})
      }
      window.open("search?q=" + encodeURIComponent(this.search), "_self");
    },
    page(e) {
      window.open(this.replaceSearch("page", e), "_self");
    },
  },
  beforeMount() {
    // 这个products是搜索结果
    this.products_page = JSON.parse(this.products);
    this.search = this.q;
  },
  watch: {
    products_page: {
      handler(newV) {
        let { data } = newV;
        if (!data) {
          this.products_list = [];
          this.products_ids = [];
          return;
        }
        this.products_list = data;
        this.products_ids = [];
        data.forEach((item) => {
          this.products_ids.push(item.ID);
        });
        if (this.palette_config) {
          this.get_product_palette(this.products_ids);
        }
        if (this.product_tag) {
          this.get_product_tag(this.products_ids);
        }
      },
      immediate: true,
    },
  },
  components: {
    vCommodityitem,
  },
};
</script>
<style  lang='scss'>
.search {
  position: relative;
  margin: 80px 0 40px;
  .searchbody {
    text-align: center;

    .searchbodytitle {
      h1 {
        margin-top: 16px;
        margin-bottom: 20px;
        font-size: 26px;
      }
      hr {
        height: 1px;
        display: block;
        margin: 20px auto 40px;
      }
    }

    .searchinput {
      width: 300px;
      margin: 40px auto 20px;
      display: flex;

      input {
        width: 10px;
        border: none;
        height: 45px;
        flex: 1;
        padding: 8px 10px;
        background: #f6f6f6;
        font-size: 18px;
      }

      span {
        width: 56px;
        height: 45px;
        line-height: 45px;
        background: #c90d0d;
        color: white;
        border: none;
        font-size: 12px;
        cursor: pointer;
      }
    }

    .searchresult {
      margin-top: 90px;
    }
  }
}

@media screen and (max-width: 370px) {
  .searchbody {
    .searchinput,
    .default-mb-filter {
      width: 90% !important;
    }
  }
}
@media screen and (min-width: 767px) {
  .filter_flex {
    margin-top: 20px;
    display: flex;
    margin-right: -15px;
    margin-left: -15px;
    align-items: flex-start;
    & > div:last-child {
      flex: 1;
      max-width: 75%;
    }
  }
}
@media screen and(max-width: 768px){
  .search {
     margin: 40px 0 40px;
     .searchbody {
       .searchbodytitle {
        hr {
          margin: 20px auto 20px;
        }
      }
      .searchinput,.default-mb-filter {
        margin: 20px auto 20px !important;
      }

    }
  }
}
</style>